import React from 'react';
import { FadeIn } from './FadeIn';
import { MonitorX, Activity, Zap } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-dark py-24 border-b border-dark-lighter" data-id="element-174">
      <div className="max-w-4xl mx-auto px-6" data-id="element-175">
        <FadeIn data-id="element-176">
          <h2 className="font-display text-4xl md:text-5xl font-bold uppercase mb-8 text-center" data-id="element-177">
            A Better Chair{' '}
            <span className="text-cyan-accent" data-id="element-178">Won't Save You</span>
          </h2>
          <p className="text-xl text-gray-300 text-center mb-16 max-w-2xl mx-auto" data-id="element-179">
            Most people think a better $1,200 ergonomic chair or a standing desk
            will save them. They won't. If your hip flexors are already
            shortened and your glutes have "shut off" from years of sitting, a
            better chair just allows you to stay locked in a painful position
            more comfortably.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-180">
            <div className="bg-dark-panel p-8 border border-dark-lighter flex flex-col items-center text-center" data-id="element-181">
              <MonitorX className="w-12 h-12 text-cyan-accent mb-6" data-id="element-182" />
              <h3 className="font-display text-2xl uppercase mb-4" data-id="element-183">
                "Tech-Neck" Headaches
              </h3>
              <p className="text-gray-400" data-id="element-184">
                Constant tension radiating from your shoulders to the base of
                your skull by 3 PM.
              </p>
            </div>
            <div className="bg-dark-panel p-8 border border-dark-lighter flex flex-col items-center text-center" data-id="element-185">
              <Activity className="w-12 h-12 text-cyan-accent mb-6" data-id="element-186" />
              <h3 className="font-display text-2xl uppercase mb-4" data-id="element-187">
                Chronic Hip Stiffness
              </h3>
              <p className="text-gray-400" data-id="element-188">
                Feeling like a rusted hinge every time you try to stand up or
                get out of your car.
              </p>
            </div>
            <div className="bg-dark-panel p-8 border border-dark-lighter flex flex-col items-center text-center" data-id="element-189">
              <Zap className="w-12 h-12 text-cyan-accent mb-6" data-id="element-190" />
              <h3 className="font-display text-2xl uppercase mb-4" data-id="element-191">
                Sciatica Flare-Ups
              </h3>
              <p className="text-gray-400" data-id="element-192">
                Shooting pain that makes you feel twenty years older than you
                actually are.
              </p>
            </div>
          </div>

          <div className="text-center" data-id="element-193">
            <p className="text-2xl font-display uppercase tracking-wide text-white border-b border-cyan-accent inline-block pb-2" data-id="element-194">
              You feel like a prisoner in a body that used to move without
              thinking.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}